// Item kinds as the server reads them (receipts-db.js ITEM_KINDS), their
// labels and colors, and how "What we bought" groups them. The grouping is
// one constant so it can change in one place.

export const KINDS = ['meat', 'produce', 'dairy_eggs', 'pantry', 'drinks', 'junk_food', 'dog_food', 'household', 'fuel', 'other'];

export const KIND_LABELS = {
  meat: 'Meat',
  produce: 'Produce',
  dairy_eggs: 'Dairy and eggs',
  pantry: 'Pantry',
  drinks: 'Drinks',
  junk_food: 'Junk food & drinks',
  dog_food: 'Dog food',
  household: 'Household',
  fuel: 'Fuel',
  other: 'Other',
};

// Bar and chip colors. Junk food is the one warm alarm color on the page.
export const KIND_COLORS = {
  meat: '#a8322d',
  produce: '#3d8b3d',
  dairy_eggs: '#2e7d6b',
  pantry: '#b8860b',
  drinks: '#2f6db0',
  junk_food: '#d4600a',
  dog_food: '#7a5230',
  household: '#5d6670',
  fuel: '#4B0082',
  other: '#9a8a7a',
};

// Real food vs junk. Everything not in real or junk is shown on its own,
// never folded into either side.
export const KIND_GROUPS = {
  real: ['meat', 'produce', 'dairy_eggs', 'pantry'],
  junk: ['junk_food'],
  separate: ['drinks', 'dog_food', 'household', 'fuel', 'other'],
};

/** A line's kind for counting: an unlabeled line is "other", never dropped. */
export const kindOf = (line) => (KINDS.includes(line?.kind) ? line.kind : 'other');

/** 'real' | 'junk' | 'separate' */
export function groupOfKind(kind) {
  if (KIND_GROUPS.real.includes(kind)) return 'real';
  if (KIND_GROUPS.junk.includes(kind)) return 'junk';
  return 'separate';
}
